export enum ChartType {
  fullView = 'MachineChartInFullView',
  downtimeTask = 'MachineChartInDowntimeTask',
  finishPhase = 'MachineChartInFinishPhase',
  editSetup = 'MachineChartInEditSetup',
  splitDowntime = 'MachineChartInSplitDowntime',
  editDowntime = 'MachineChartInEditDowntime'
}
